import script from "./DailyCompletionChart.vue?vue&type=script&setup=true&lang=js"
export * from "./DailyCompletionChart.vue?vue&type=script&setup=true&lang=js"

import "./DailyCompletionChart.vue?vue&type=style&index=0&id=d04ea28e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d04ea28e"]])

export default __exports__